import { Component } from '@angular/core';

import { InputLogoComponent, UploadComponent, VatNumberComponent } from '@camelot/form-input';
import { InputLogo, InputUpload, InputVatNumber } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [InputLogoComponent, TestIdDirective, UploadComponent, VatNumberComponent],
    template: `
    <cam-input-logo camTestId="cam-input-logo" [input]="this.logo" [standalone]="true" />
    <cam-input-upload camTestId="cam-input-upload" [input]="this.upload" [standalone]="true" />
    <cam-input-vat-number camTestId="cam-input-vat-number" [input]="this.vatNumber" [standalone]="true" />
  `
})
export class FormInputsBackendCase {
  public logo = new InputLogo({ key: 'logo', label: 'Logo' });
  public upload = new InputUpload({ key: 'upload', label: 'Upload' });
  public vatNumber = new InputVatNumber({ key: 'vat', label: 'VAT number' });
}
